exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".social-invite-text___aIS9D {\n  margin: 40px 0 20px 0;\n}\n.center-text___1-6yi {\n  text-align: center;\n}\n.extra-margin___28Ixh {\n  margin: 30px 0 0 0;\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/components/confirmationPage.less"],"names":[],"mappings":"AAAA;EACE,sBAAsB;CACvB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;CACpB","file":"confirmationPage.less","sourcesContent":[".social-invite-text {\n  margin: 40px 0 20px 0;\n}\n.center-text {\n  text-align: center;\n}\n.extra-margin {\n  margin: 30px 0 0 0;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"social-invite-text": "social-invite-text___aIS9D",
	"center-text": "center-text___1-6yi",
	"extra-margin": "extra-margin___28Ixh"
};